import { Trash2, UploadCloud, Check } from "lucide-react";

export default function PersonCard({
  person,
  index,
  active,
  onSelect,
  onChange,
  onRemove,
  onPickPhoto,
  canRemove,
}) {
  return (
    <div
      data-testid={`person-card-${index}`}
      onClick={onSelect}
      className={`rounded-2xl border-2 p-4 cursor-pointer transition-all ${
        active
          ? "border-[#299fe0] bg-[#299fe0]/5"
          : "border-slate-200 bg-white hover:border-slate-400"
      }`}
    >
      <div className="flex items-start gap-4">
        <button
          type="button"
          data-testid={`person-photo-${index}`}
          onClick={(e) => {
            e.stopPropagation();
            onPickPhoto();
          }}
          className="relative w-[70px] h-[90px] shrink-0 rounded-xl overflow-hidden bg-slate-900 border border-slate-200 flex items-center justify-center text-white/70"
        >
          {person.imageUrl ? (
            <img
              src={person.imageUrl}
              alt={`Person ${index + 1}`}
              className="w-full h-full object-cover"
            />
          ) : (
            <UploadCloud size={20} />
          )}
        </button>

        <div className="flex-1 min-w-0 space-y-2">
          <div className="flex items-center justify-between gap-2">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">
              {active && <Check size={13} className="text-[#299fe0]" />}
              Person {index + 1}
            </div>
            <div className="flex items-center gap-2">
              <label className="text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-500">
                Copies
              </label>
              <input
                type="number"
                min={1}
                max={60}
                value={person.copies}
                data-testid={`person-copies-${index}`}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) =>
                  onChange({
                    copies: Math.max(1, Math.min(60, Number(e.target.value) || 1)),
                  })
                }
                className="w-16 px-2 py-1.5 rounded-lg bg-white border border-slate-200 focus:border-[#299fe0] outline-none font-semibold text-sm text-center"
              />
              {canRemove && (
                <button
                  type="button"
                  data-testid={`person-remove-${index}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemove();
                  }}
                  className="w-8 h-8 rounded-lg bg-slate-100 hover:bg-[#fee2e2] hover:text-[#b91c1c] text-slate-500 flex items-center justify-center"
                  aria-label={`Remove person ${index + 1}`}
                >
                  <Trash2 size={14} />
                </button>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
            <Field
              label="Name"
              testid={`person-name-${index}`}
              value={person.name}
              placeholder="Sachin Taman"
              maxLength={32}
              onChange={(v) => onChange({ name: v })}
            />
            <Field
              label="DOB"
              testid={`person-date-${index}`}
              value={person.date}
              placeholder="01/01/1999"
              maxLength={16}
              onChange={(v) => onChange({ date: v })}
            />
            <Field
              label="ID"
              testid={`person-id-${index}`}
              value={person.idNo}
              placeholder="123131XXXXX989XX"
              maxLength={28}
              onChange={(v) => onChange({ idNo: v })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, testid, value, placeholder, maxLength, onChange }) {
  return (
    <div>
      <label className="block text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-500 mb-1">
        {label}
      </label>
      <input
        type="text"
        value={value}
        data-testid={testid}
        placeholder={placeholder}
        maxLength={maxLength}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-2.5 py-2 rounded-lg bg-white border border-slate-200 focus:border-[#299fe0] focus:ring-4 focus:ring-[#299fe0]/15 outline-none text-sm font-medium"
      />
    </div>
  );
}
